/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Col_ExampleInputs */

const tr_katalog_desi_page_col_example = /** @type {(inputs: Katalog_Desi_Page_Col_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Örnek ölçü (cm)`)
};

const en_katalog_desi_page_col_example = /** @type {(inputs: Katalog_Desi_Page_Col_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example size (cm)`)
};

const de_katalog_desi_page_col_example = /** @type {(inputs: Katalog_Desi_Page_Col_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispielmaß (cm)`)
};

const ru_katalog_desi_page_col_example = /** @type {(inputs: Katalog_Desi_Page_Col_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пример размера (см)`)
};

/**
* | output |
* | --- |
* | "Example size (cm)" |
*
* @param {Katalog_Desi_Page_Col_ExampleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_col_example = /** @type {((inputs?: Katalog_Desi_Page_Col_ExampleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Col_ExampleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_col_example(inputs)
	if (locale === "de") return de_katalog_desi_page_col_example(inputs)
	if (locale === "ru") return ru_katalog_desi_page_col_example(inputs)
	return tr_katalog_desi_page_col_example(inputs)
});